import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-skills-certificate-table',
  templateUrl: './skills-certificate-table.component.html',
  styleUrls: ['./skills-certificate-table.component.css']
})
export class SkillsCertificateTableComponent implements OnInit {
    public grid?: GridOptions;

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_skillscertificatetable.grid')
                .setLoadDataFunction({
                    method: 2508,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
